import { Quaternion } from '@trimble-gcs/common';
import { SectionBox } from 'trimble-connect-workspace-api';
import { ClipBox } from './clip-box.models';

const MM_TO_M = 1 / 1000;
const RAD_TO_DEG = 180 / Math.PI;

/**
 * Maps a Connect viewer SectionBox (mm, quaternion) to api ClipBoxFilter (metres, XYZ Euler degrees).
 * XYZ order matches Spark `GeoUtils.rotatePoint`. Scala follow-up: inverse rotation order is wrong
 * for multi-axis rotations (TRCPS-18).
 */
export function sectionBoxToClipBox(sectionBox: SectionBox): ClipBox {
  const origin = {
    x: sectionBox.positionX * MM_TO_M,
    y: sectionBox.positionY * MM_TO_M,
    z: sectionBox.positionZ * MM_TO_M,
  };

  const size = {
    x: sectionBox.sizeX * MM_TO_M,
    y: sectionBox.sizeY * MM_TO_M,
    z: sectionBox.sizeZ * MM_TO_M,
  };

  const eulerRadians = Quaternion.toEulerAngles(
    new Quaternion(
      sectionBox.rotationX,
      sectionBox.rotationY,
      sectionBox.rotationZ,
      sectionBox.rotationW,
    ),
    'XYZ',
  );

  const rotation = {
    x: eulerRadians.x * RAD_TO_DEG,
    y: eulerRadians.y * RAD_TO_DEG,
    z: eulerRadians.z * RAD_TO_DEG,
  };

  return { origin, size, rotation };
}
